<template>
  <div v-show="pageShow">
    <Header/>
    <div class="content-wrapper">
      <div class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h1 class="m-0 text-dark">บทความ</h1>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item active">บทความ</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- Content body. -->
      <section class="content">
        <div class="container-fluid">
          <div class="card">
            <div class="card-header d-flex">
              <div class="col-2"></div>
              <div class="col-10 text-right">
                <button class="btn btn-sm btn-primary" @click="addArticle()">
                  เพิ่มบทความ
                  <i class="fas fa-plus"></i>
                </button>
              </div>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table id="dataTable" class="table table-hover table-striped table-bordred">
                  <thead class="thead-light">
                    <tr>
                      <th>No.</th>
                      <th>ชื่อบทความ</th>
                      <th>ชื่อที่มา</th>
                      <th>ลิงค์ที่มา</th>
                      <th>วันที่บันทึก</th>
                      <th>แก้ไข</th>
                      <th>ลบ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(article,index) in articles" :key="article.index">
                      <td>{{++index}}</td>
                      <td>{{article.article_name}}</td>
                      <td>{{article.ref_name}}</td>
                      <td>{{article.ref_link}}</td>
                      <td>{{article.created_at}}</td>
                      <td>
                        <button
                          class="btn btn-link btn-sm text-warning"
                          @click="editArticle(article)"
                        >
                          <i class="fas fa-edit"></i> Edit
                        </button>
                      </td>
                      <td>
                        <button
                          class="btn btn-link btn-sm text-danger"
                          @click="deleteArticle(article)"
                        >
                          <i class="fas fa-trash"></i> Delete
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- Modal -->
      <div class="modal" id="modalArticle">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">{{titleModal}}</h4>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <form @submit.prevent="actionForm ? updateArticle() : saveArticle() ">
              <div class="modal-body">
                <div class="form-group">
                  <label>ชื่อบทความ</label>
                  <input
                    type="text"
                    placeholder="ป้อนชื่อบทความ"
                    class="form-control"
                    required
                    v-model="form.article_name"
                  >
                </div>
                <div class="form-group">
                  <label>ชื่อที่มา</label>
                  <input
                    type="text"
                    placeholder="ป้อนชื่อที่มา"
                    class="form-control"
                    required
                    v-model="form.ref_name"
                  >
                </div>
                <div class="form-group">
                  <label>ลิงค์่มา</label>
                  <input
                    type="text"
                    placeholder="ป้อนลิงค์ที่มา"
                    class="form-control"
                    required
                    v-model="form.ref_link"
                  >
                </div>
                <div class="form-group">
                  <label>รายละเอียด</label>
                  <vue-editor v-model="form.article_detail"></vue-editor>
                </div>
                <div class="form-group">
                  <label>รูปภาพ</label>
                  <img :src="getImage()" class="img-fluid" v-show="actionImg">
                  <input
                    type="file"
                    @change="pathFile"
                    name="path_file"
                    id="path_file"
                    ref="path_file"
                    class="form-control-file"
                  >
                  <span class="text-danger">** ขนาดรูปภาพ 800 x 660 (.jpg, .png เท่านั้น) **</span>
                </div>
              </div>
              <div class="modal-footer">
                <button class="btn btn-success" type="submit">{{btnSubmit}}</button>
                <button type="button" class="btn btn-danger" data-dismiss="modal">ยกเลิก</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/HeaderBack";
import { VueEditor } from "vue2-editor";
export default {
  components: {
    Header,
    VueEditor
  },
  data() {
    return {
      pageShow: false,
      titleModal: "",
      btnSubmit: "",
      actionForm: false,
      form: new Form({
        article_id: "",
        article_name: "",
        path_file: "",
        article_detail: "",
        ref_name: "",
        ref_link: ""
      }),
      actionImg: false,
      uploadImg: "",
      articles: {}
    };
  },
  beforeCreate() {
    this.axios
      .post(
        "http://pgm01.toonjob.com/2019/BannKlong/project/checkBeforeLogin",
        {
          keyid: this.$session.get("keyid"),
          keyserial: this.$session.get("keyserial"),
          keytoken: this.$session.get("keytoken")
        }
      )
      .then(response => {
        if (response.data.checkLogin === 0) {
          this.pageShow = false;
          window.location.href = "/pageLogin";
        } else {
          this.pageShow = true;
        }
      });
  },
  methods: {
    addArticle() {
      this.form.reset();
      $("#modalArticle").modal("show");
      this.titleModal = "เพิ่มบทความ";
      this.btnSubmit = "บันทึกข้อมูล";
      this.actionForm = false;
      this.actionImg = false;
    },
    editArticle(article) {
      this.form.fill(article);
      $("#modalArticle").modal("show");
      this.titleModal = "แก้ไขบทความ";
      this.btnSubmit = "แก้ไขและบันทึกข้อมูล";
      this.actionForm = true;
      this.actionImg = true;
    },
    saveArticle() {
      let dataForms = new FormData();
      dataForms.append("path_file", this.uploadImg);
      dataForms.append("article_name", this.form.article_name);
      dataForms.append("article_detail", this.form.article_detail);
      dataForms.append("ref_name", this.form.ref_name);
      dataForms.append("ref_link", this.form.ref_link);
      const config = { headers: { "Content-Type": "multipart/form-data" } };
      this.axios
        .post(
          "http://pgm01.toonjob.com/2019/BannKlong/project/saveArticle",
          dataForms,
          config
        )
        .then(response => {
          $("#modalArticle").modal("hide");
          this.form.reset();
          this.uploadImg = "";
          toast.fire({
            type: "success",
            title: response.data.message
          });
          Fire.$emit("AfterArticle");
        });
    },
    updateArticle() {
      let dataForms = new FormData();
      dataForms.append("path_file", this.uploadImg);
      dataForms.append("article_id", this.form.article_id);
      dataForms.append("article_name", this.form.article_name);
      dataForms.append("article_detail", this.form.article_detail);
      dataForms.append("ref_name", this.form.ref_name);
      dataForms.append("ref_link", this.form.ref_link);
      const config = { headers: { "Content-Type": "multipart/form-data" } };
      this.axios
        .post(
          "http://pgm01.toonjob.com/2019/BannKlong/project/updateArticle",
          dataForms,
          config
        )
        .then(response => {
          $("#modalArticle").modal("hide");
          this.form.reset();
          this.uploadImg = "";
          toast.fire({
            type: "success",
            title: response.data.message
          });
          Fire.$emit("AfterArticle");
        });
    },
    deleteArticle(article) {
      this.form.fill(article);
      swal
        .fire({
          title: "Are you sure?",
          text: "You won't delete this acticle!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!"
        })
        .then(result => {
          if (result.value) {
            this.form
              .post(
                "http://pgm01.toonjob.com/2019/BannKlong/project/deleteArticle"
              )
              .then(response => {
                swal.fire("Deleted!", response.data.message, "success");
                Fire.$emit("AfterArticle");
              });
          }
        });
    },
    dataArticle() {
      this.axios
        .get("http://pgm01.toonjob.com/2019/BannKlong/project/dataArticle")
        .then(response => {
          this.articles = response.data;
          $(document).ready(function() {
            $("#dataTable").DataTable();
          });
        });
    },
    pathFile(e) {
      this.actionImg = true;
      let file = e.target.files[0];
      let reader = new FileReader();
      if (file["type"] === "image/jpeg" || file["type"] === "image/png") {
        this.uploadImg = this.$refs.path_file.files[0];
        reader.onload = file => {
          this.form.path_file = reader.result;
        };
        reader.readAsDataURL(file);
      } else {
        swal.fire({
          type: "error",
          title: "Opps...",
          text: "You are uploading a large file"
        });
      }
    },
    getImage() {
      let photo =
        this.form.path_file.length > 200
          ? this.form.path_file
          : "http://pgm01.toonjob.com/2019/BannKlong/image/articles/" +
            this.form.path_file;
      return photo;
    }
  },
  created() {
    this.$Progress.start()
    this.dataArticle();
    Fire.$on("AfterArticle", () => {
      this.dataArticle();
    });
    this.$Progress.finish()
  }
};
</script>


// WEBPACK FOOTER //
// src/backEnd/Article.vue